import React, { useState, useEffect } from "react";

import "react-awesome-lightbox/build/style.css";
import { Card, Container, Row, Col } from "react-bootstrap";
import Lightbox from "react-awesome-lightbox";

import moment from "moment"
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import "../../../../../../styles/app/pages/CampaingPreview.scss";
import "./fix.css"
import ManagerTasks from "./ManagerTasks"


const responsive_dtls = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 2,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    }
};

const addCommas = function (input) {
    // If the regex doesn't match, `replace` returns the string unmodified
    return (input.toString()).replace(
        // Each parentheses group (or 'capture') in this regex becomes an argument 
        // to the function; in this case, every argument after 'match'
        /^([-+]?)(0?)(\d+)(.?)(\d+)$/g, function (match, sign, zeros, before, decimal, after) {

            // Less obtrusive than adding 'reverse' method on all strings
            var reverseString = function (string) { return string.split('').reverse().join(''); };

            // Insert commas every three characters from the right
            var insertCommas = function (string) {

                // Reverse, because it's easier to do things from the left
                var reversed = reverseString(string);

                // Add commas every three characters
                var reversedWithCommas = reversed.match(/.{1,3}/g).join(',');

                // Reverse again (back to normal)
                return reverseString(reversedWithCommas);
            };

            // If there was no decimal, the last capture grabs the final digit, so
            // we have to put it back together with the 'before' substring
            return sign + (decimal ? insertCommas(before) + decimal + after : insertCommas(before + after));
        }
    );
};
export function priceFormatter(column) {
    return (
        <h6><strong>{Number((column.footer || 0).toFixed(2))}%</strong></h6>
    );
}
export function unitsFormatter(column) {
    return (
        <h6><strong>{addCommas(Number(column.footer ?? 0).toFixed(0))}</strong></h6>
    );
}

export const Report5 = ({ props, campaign, competition }) => {
    const _rows = props.rows.sort((a, b) => a.no - b.no);
    const [image, setImage] = useState(null)

    const pos_length = campaign?.pos?.length
    const [pos_selected, pos_setSelected] = useState([]);


    const [products_selected, products_setSelected] = useState([]);


    useEffect(() => {
        const pos_map = _rows.map((key) => key.pos);
        const pos_unique = [...new Set(pos_map)];
        const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
        pos_setSelected(pos_options.sort((a, b) => {
            if (a.label < b.label) { return -1 }
            if (a.label > b.label) { return 1 }
            return 0
        }));

        const product_map = _rows.map((key) => key.product);
        const product_unique = [...new Set(product_map)];
        const product_options = product_unique.map((key) => ({
            label: key,
            value: key,
        }));
        products_setSelected(product_options)


    }, [_rows, props.tasks]);

    const raw = _rows
    // .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
    // .filter((row) => round_selected.map((row) => row.value).includes(row.round))
    // .filter((row) => agent_selected.map((row) => row.value).includes(row.agent))
    // .filter((row) => products_selected.map((row) => row.value).includes(row.product) || !row.product);
    const target = campaign.pos.length * Object.values(campaign.products).length

    const agents = raw.reduce((hash, row) => ({
        ...hash,
        [row.agent]: [row, ...(hash[row.agent] ?? [])]
    }), {})
    const report = _rows
    const pos = [...new Set(report.map(row => row.pos))]
    const pos_visited = pos.length


    const best = _rows.filter(row => row.rate === 5 && row.comment)
    const baddest = _rows.filter(row => row.rate === 1 && row.comment)

    return (
        <Card.Body className="p-1 mt-1">
            {image && <Lightbox image={image} onClose={() => setImage(null)} />}

            <Container fluid>
                <Row className="w-100 justify-content-end"></Row>



                <div className="pl-6 row d-flex justify-content-center">
                    <div className="card w-50">
                        <div className="row w-100 p-4">
                            <div className="col-12 text-center">
                                <span className="h3"> <strong>Variables</strong></span>
                            </div>
                            <div className="col-6 text-center">
                                <span className="text-muted h3">PDV: </span> <strong className="h3">{pos_length}</strong>
                            </div>

                            <div className="col-6 text-center">
                                <span className="text-muted h3">SKU: </span> <strong className="h3">{Object.values(campaign.products).length}</strong>
                            </div>
                            <div className="col-6 text-center">
                                <span className="text-muted h3">PDV Visitados: </span> <strong className="h3">{pos_visited}</strong>
                            </div>
                            <div className="col-6 text-center">
                                <span className="text-muted h3">Cant. Preguntas Teoricas: </span> <strong className="h3">{target}</strong>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="row">
                    {props.tasks
                        .map(task => (
                            <ManagerTasks
                                product_options={products_selected}
                                pos_options={pos_selected}
                                row={raw}
                                competition={competition}
                                target={target}
                                campaign={campaign}
                                task={task} />
                        ))}
                    {/*                   
                    {task_yesno
                        .filter(wc)
                        .map(task => (
                            <ExecutiveSummary
                                campaign={campaign}
                                raw={raw}
                                mainTask={task.value}
                                pos_options={pos_selected}
                                product_options={products_selected}
                                task_options={task_yesno}
                            />
                        ))}
                    {task_quantity
                        .filter(wc)
                        .map((task, key) => (
                            <ExecutiveSummaryBar
                                campaign={campaign}
                                raw={raw}
                                length={(task_quantity.filter(wc).length - 1) * 3}
                                total={(task_quantity.filter(wc).length + task_yesno.filter(wc).length * 3)}
                                item={key}
                                mainTask={task.value}
                                pos_options={pos_selected}
                                product_options={products_selected}
                                task_options={task_yesno}
                                target={target}
                            />
                        ))}
                    {task_quantity
                        .filter(wc)
                        .map((task, key) => (
                            <ExecutiveSummaryBarByDate
                                campaign={campaign}
                                raw={raw}
                                length={(task_quantity.filter(wc).length - 1) * 2}
                                total={(task_quantity.filter(wc).length + task_yesno.filter(wc).length) * 2}
                                item={key}
                                mainTask={task.value}
                                pos_options={pos_selected}
                                product_options={products_selected}
                                task_options={task_yesno}
                                target={target}
                            />
                        ))}
                    {task_quantity
                        .filter(wc)
                        .map((task, key) => (
                            <ExecutiveSummaryBarPie
                                campaign={campaign}
                                raw={raw}
                                length={(task_quantity.filter(wc).length - 1)}
                                total={(task_quantity.filter(wc).length + task_yesno.filter(wc).length)}
                                item={key}
                                mainTask={task.value}
                                pos_options={pos_selected}
                                product_options={products_selected}
                                task_options={task_yesno}
                                target={target}
                            />
                        ))} */}

                </div>
                {best.length || baddest.length ?
                    <>
                        <div className="row pt-2">
                            <div className="col-12 text-center p-2">
                                <h1> RATINGS </h1>

                            </div>
                            <div className="col-6 text-centert p-2">
                                <div className="card p-2 shadow-sm">

                                    <h3 className="pl-4">
                                        <strong>
                                            <i class="fas fa-star fa-1x" style={{ color: "#28a745" }}></i>
                                            <i class="fas fa-star fa-1x" style={{ color: "#28a745" }}></i>
                                            <i class="fas fa-star fa-1x" style={{ color: "#28a745" }}></i>
                                            <i class="fas fa-star fa-1x" style={{ color: "#28a745" }}></i>
                                            <i class="fas fa-star fa-1x" style={{ color: "#28a745" }}></i>
                                        </strong>
                                    </h3>
                                    <Carousel
                                        swipeable={false}
                                        draggable={false}
                                        showDots={true}
                                        responsive={responsive_dtls}
                                        ssr={true} // means to render carousel on server-side.
                                        infinite={false}
                                        autoPlay={false}
                                        autoPlaySpeed={1000}
                                        keyBoardControl={false}
                                        customTransition="all .5"
                                        transitionDuration={1000}
                                        containerClass="carousel-container"
                                        removeArrowOnDeviceType={["tablet", "mobile"]}
                                        itemClass="carousel-item-padding-40-px"
                                    >
                                        {best
                                            .filter(row => row.image)
                                            .slice(0, 5)
                                            .map((row, key) => {
                                                const date = row.write + " " + row.write_time

                                                return <Col xs={12} key={key} style={{ minHeight: "375px" }}>
                                                    <Card className="p-2 shadow-sm">
                                                        <Row className="d-flex justify-content-center w-100 text-center">
                                                            <Col xs={12}>
                                                                <img
                                                                    alt="product"
                                                                    className="image-fluid rounded cursor-pointer margin-auto"
                                                                    height="150px"
                                                                    onClick={() => setImage(row.image)}
                                                                    width="150px"
                                                                    src={row.image}
                                                                />
                                                            </Col>

                                                            <Col>
                                                                {row.product ?
                                                                    <>
                                                                        <small className="text-muted">PRODUCT:</small>
                                                                        <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                                                            {row.product}
                                                                        </p>
                                                                    </> :
                                                                    <>
                                                                        <small className="text-muted">ACTION:</small>
                                                                        <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                                                            {row.task.toUpperCase()}
                                                                        </p>
                                                                    </>}
                                                                <small className="test-muted">POS:</small>
                                                                <p className="font-weight-bold" style={{ fontSize: "14px", marginBottom: "2px" }}>
                                                                    {row.pos}
                                                                </p>
                                                                <small className="text-muted">TASK:</small>
                                                                {row.product ? <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                                                                    {row.task}
                                                                </p> : null}

                                                                {row.comment ? <>
                                                                    <small className="text-muted">COMMENT:</small>
                                                                    <p className="font-weight-bold" style={{ fontSize: "14px", marginBottom: "2px" }}>
                                                                        {row.comment}
                                                                    </p> </> : null}
                                                                <small className="text-muted">Date/Time:</small>
                                                                <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                                                                    {date}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                    <br />
                                                </Col>
                                            })}

                                    </Carousel>
                                </div>


                            </div>
                            <div className="col-6 text-center p-2">
                                <div className="card p-2 shadow-sm">
                                    <h3 className="pr-4">
                                        <strong>
                                            <i class="far fa-star fa-1x" style={{ color: "#dc3545" }}></i>
                                            <i class="far fa-star fa-1x" style={{ color: "#dc3545" }}></i>
                                            <i class="far fa-star fa-1x" style={{ color: "#dc3545" }}></i>
                                            <i class="far fa-star fa-1x" style={{ color: "#dc3545" }}></i>
                                            <i class="fa fa-star fa-1x" style={{ color: "#dc3545" }}></i>
                                        </strong>
                                    </h3>
                                    <Carousel
                                        swipeable={false}
                                        draggable={false}
                                        showDots={true}
                                        responsive={responsive_dtls}
                                        ssr={true} // means to render carousel on server-side.
                                        infinite={false}
                                        autoPlay={false}
                                        autoPlaySpeed={1000}
                                        keyBoardControl={false}
                                        customTransition="all .5"
                                        transitionDuration={1000}
                                        containerClass="carousel-container"
                                        removeArrowOnDeviceType={["tablet", "mobile"]}
                                        itemClass="carousel-item-padding-40-px"
                                    >
                                        {baddest
                                            .filter(row => row.image)
                                            .slice(0, 5)
                                            .map((row, key) => {
                                                const date = row.write + " " + row.write_time

                                                return <Col xs={12} key={key} style={{ minHeight: "375px" }}>
                                                    <Card className="p-2 shadow-sm">
                                                        <Row className="d-flex justify-content-center w-100 text-center">
                                                            <Col xs={12}>
                                                                <img
                                                                    alt="product"
                                                                    className="image-fluid rounded cursor-pointer margin-auto"
                                                                    height="150px"
                                                                    onClick={() => setImage(row.image)}
                                                                    width="150px"
                                                                    src={row.image}
                                                                />
                                                            </Col>

                                                            <Col>
                                                                {row.product ?
                                                                    <>
                                                                        <small className="text-muted">PRODUCT:</small>
                                                                        <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                                                            {row.product}
                                                                        </p>
                                                                    </> :
                                                                    <>
                                                                        <small className="text-muted">ACTION:</small>
                                                                        <p style={{ fontSize: "12px", marginBottom: "2px" }}>
                                                                            {row.task.toUpperCase()}
                                                                        </p>
                                                                    </>}
                                                                <small className="test-muted">POS:</small>
                                                                <p className="font-weight-bold" style={{ fontSize: "14px", marginBottom: "2px" }}>
                                                                    {row.pos}
                                                                </p>
                                                                <small className="text-muted">TASK:</small>
                                                                {row.product ? <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                                                                    {row.task}
                                                                </p> : null}

                                                                {row.comment ? <>
                                                                    <small className="text-muted">COMMENT:</small>
                                                                    <p className="font-weight-bold" style={{ fontSize: "14px", marginBottom: "2px" }}>
                                                                        {row.comment}
                                                                    </p> </> : null}
                                                                <small className="text-muted">Date/Time:</small>
                                                                <p style={{ fontSize: "10px", marginBottom: "2px" }}>
                                                                    {date}
                                                                </p>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                    <br />
                                                </Col>
                                            })}
                                    </Carousel>

                                </div>

                            </div>
                        </div>
                    </>
                    : null
                }
                <div className="row">

                    {Object.entries(agents)
                        .map(([agent, results]) => (
                            <PromotorDetails
                                results={results}
                                agent={agent}
                                target={pos_length}
                            />
                        ))}
                </div>

            </Container>
        </Card.Body>
    );
};


function PromotorDetails({ agent, results, target }) {
    const [image, setImage] = useState(null)
    const sorted_by_pos = results.sort((a, b) => {
        if (a.pos > b.pos) { return 1 }
        if (a.pos < b.pos) { return -1 }
        return 0
    })
    let tmp_pos = ""
    let start_time = null
    let end_time = null
    const pos = [...new Set(results.map(row => row.pos))]

    const average = sorted_by_pos.reduce((total, row) => {
        if (!tmp_pos) {
            tmp_pos = row.pos
            start_time = row.write + " " + row.write_time
        }
        if (tmp_pos === row.pos) {
            end_time = row.write + " " + row.write_time
        } else {
            const startTime = moment(start_time, "MMMM/DD/YY HH:mm:ss")
            const current = row.write + " " + row.write_time
            const end = moment(end_time || current, "MMMM/DD/YY HH:mm:ss")
            end_time = null
            tmp_pos = ""
            return Math.abs(startTime.diff(end, 'minutes', true)) + total
        }
        return total
    }, 0) / pos.length
    const pos_visited = pos.length

    return (
        <div className="col-12">
            {image && <Lightbox image={image} onClose={() => setImage(null)} />}

            <div className="card p-4">
                <div className="row">
                    <div className="col-12">
                        <div className="card shadow-sm">
                            <div className="card-header">
                                <h5 style={{ color: "#5E78FF" }}>PROMOTOR: {agent}</h5>

                            </div>
                            <div className="card-body row">
                                <div className="col row">
                                    <div className="col-md-4 col-lg-4 pt-1 text-right d-flex w-100 justify-content-end">
                                        <i class="fas fa-store fa-3x" style={{ color: "#5E78FF" }}></i>
                                    </div>
                                    <div className="col-md-8 col-lg-8">
                                        <label>
                                            TOTAL DE TIENDAS VISITADAS
                                        </label>
                                        <h4>
                                            <strong>
                                                {pos_visited}
                                            </strong>
                                        </h4>
                                    </div>
                                </div>
                                <hr />
                                <div className="col row">
                                    <div className="col-md-4 col-lg-4 pt-1 text-right d-flex w-100 justify-content-end">
                                        <i class="fas fa-clock fa-3x" style={{ color: "#5E78FF" }}></i>
                                    </div>
                                    <div className="col-md-8 col-lg-8">
                                        <label>
                                            TIEMPO PROMEDIO EN PDV
                                        </label>
                                        <h4>
                                            <strong>
                                                {average.toFixed(0)} MIN
                                            </strong>
                                        </h4>
                                    </div>
                                </div>
                                <hr />
                                <div className="col row">
                                    <div className="col-md-4 col-lg-4 pt-1 text-right d-flex w-100 justify-content-end">
                                        <i class="fas fa-chart-bar fa-3x" style={{ color: "#5E78FF" }}></i>
                                    </div>
                                    <div className="col-md-8 col-lg-8">
                                        <label>
                                            CUMPLIMIENTOS DE VISITAS PROGRAMADAS
                                        </label>
                                        <h4>
                                            <strong>
                                                {Number(((pos_visited / (target || 1)) * 100).toFixed(2))}%
                                            </strong>
                                        </h4>
                                    </div>
                                </div>
                                <hr />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}






